import React, { useRef, useEffect, useState } from 'react'
import Img from 'gatsby-image/withIEPolyfill'
import "intersection-observer"
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { useEase } from './motion';
import { Pullstate } from '../components/pullstate'

export const CoverImage = (props) => {
	const isEdgeHTML = Pullstate.useState(s => s.isEdgeHTML)

	const scanCheck = props.screen ? 'scan-lines': ''
	const imageFit = props.imgFit ? props.imgFit: ''
	const imageTag = props.imgTag ? props.imgTag: ''
	const hasMobile = props.mobile ? 'coverDesktop' : ''
	const coverClasses = `coverImage fit-${imageFit}`
	const imgClasses = `${scanCheck} ${imageTag} ${hasMobile}`

	const coverScreenAnime = {
		closed: {
			scaleX: isEdgeHTML ? 0 : 1,
			transformOrigin: "right",
			transition: {
				ease: useEase("easeOutQuart"),
				duration: 1,
			},
		},
		open: {
			scaleX: 0,
			transformOrigin: "right",
			transition: {
				ease: useEase("easeOutQuart"),
				duration: 0.75,
				delay: 0.5,
			},
		},
	}

	return (
		<div className={coverClasses}>
			<motion.div
				className="coverScreen"
				initial="closed"
				//animate={props.whisperEnd ? "open" : "closed"}
				animate={props.coverLoaded ? "open" : "closed" }
				variants={coverScreenAnime}
				exit="closed"
			></motion.div>
			<Img
				className={imgClasses}
				fluid={props.imgSrc}
				durationFadeIn={0}
				loading="eager"
				onLoad={props.toggleCoverLoad}
				objectFit="cover"
				objectPosition={
					props.objectPosition
						? props.objectPosition
						: "center center"
				}
			/>
			{props.mobile && (
				<Img
					className="coverMobile"
					fluid={props.mobile}
					durationFadeIn={0}
					loading="eager"
					objectFit="cover"
					objectPosition={
						props.objectPosition
							? props.objectPosition
							: "center center"
					}
				/>
			)}
		</div>
	)
}

export const ImageGrid = (props) => {

	const [gridRef, inView] = useInView({
		triggerOnce: false,
		threshold: props.threshold ? props.threshold : 0.3,
	});

	const gridId = props.grid ? props.grid : ''
	const gridClass = `set-${gridId}`
	const classes = `imageGrid ${gridClass}`

	const children = React.Children.map(props.children, (child, index) => {
		return React.cloneElement(child, {
				index,
				staggerIndex: index,
				cellId: `img-${parseInt(gridId) + (index + 1)}`,
				gridVisible: inView
		});
	});

	return (
		<div className={classes} ref={gridRef}>
			{children}
		</div>
	)

}

export const ImageCell = (props) => {
	const isEdgeHTML = Pullstate.useState(s => s.isEdgeHTML)

	const cellId = props.cellId ? props.cellId : ''
	const direction = props.transition ? props.transition : ''
	const classes = `imageCell ${cellId}`
	const screenClasses = `imageScreen screen-${direction}`

	//const staggerDelay = (props.staggerIndex + 1) * 0.15;
	const staggerDelay = 0.5

	const screenLeft = {
		closed: {
			scaleX: isEdgeHTML ? 0 : 1,
			transformOrigin: 'left',
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1.35,
				delay: 0.3,
			},
		},
		open: {
			scaleX: 0,
			transformOrigin: 'left',
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1,
				delay: staggerDelay
			},
		}
	}

	const screenRight = {
		closed: {
			scaleX: isEdgeHTML ? 0 : 1,
			transformOrigin: "right",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1.35,
				delay: 0.3,
			},
		},
		open: {
			scaleX: 0,
			transformOrigin: "right",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1,
				delay: staggerDelay,
			},
		},
	}

	const screenTop = {
		closed: {
			scaleY: isEdgeHTML ? 0 : 1,
			transformOrigin: "top",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1.35,
				delay: 0.3,
			},
		},
		open: {
			scaleY: 0,
			transformOrigin: "top",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1,
				delay: staggerDelay,
			},
		},
	}

	const screenBottom = {
		closed: {
			scaleY: isEdgeHTML ? 0 : 1,
			transformOrigin: "bottom",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1.35,
				delay: 0.3,
			},
		},
		open: {
			scaleY: 0,
			transformOrigin: "bottom",
			transition: {
				ease: [0.25, 1, 0.5, 1],
				duration: 1,
				delay: staggerDelay,
			},
		},
	}

	const animation = (transition) => {
		if ( transition === 'left' ) {
			return screenLeft;
		}
		if ( transition === 'right' ) {
			return screenRight;
		}
		if ( transition === 'top' ) {
			return screenTop;
		}
		if ( transition === 'bottom' ) {
			return screenBottom;
		}

	}

	return (

		<div className={classes}>
			<motion.div
				className={screenClasses}
				initial='closed'
				animate={props.gridVisible? 'open' : 'closed'}
				variants={animation(props.transition)}
				exit='closed'
			>
			</motion.div>
			<Img
				loading='eager'
				fluid={props.src}
				backgroundColor='white'
				objectFit='cover'
				objectPosition={props.objectPosition ? props.objectPosition : 'center center'}
			/>
		</div>
	)
}
